// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style-sub-item[data-v-635d95c0] {
  background-color: #F7F7F7;
  padding: 9px 12px;
  min-height: 36px;
  border-radius: 4px;
  margin-bottom: 8px;
}
.style-sub-item .sub-item-title[data-v-635d95c0] {
  color: var(--bi-jz-font-color);
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  user-select: none;
  transition: all 0.2s ease;
}
.style-sub-item .sub-item-title[data-v-635d95c0]:hover {
  color: #2e74ff;
}
.style-sub-item .sub-item-title i[data-v-635d95c0] {
  margin-right: 6px;
  transition: transform 0.3s ease;
  font-size: 12px;
}
.style-sub-item .sub-item-title i.is-expanded[data-v-635d95c0] {
  transform: rotate(90deg);
}
.style-sub-item .sub-item-content[data-v-635d95c0] {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease, padding 0.3s ease;
  padding: 0;
}
.style-sub-item .sub-item-content.is-expanded[data-v-635d95c0] {
  max-height: 1000px;
  padding: 12px 0 0 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/base/styleSubItem.vue","webpack://./styleSubItem.vue"],"names":[],"mappings":"AAoCA;EACI,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;ACnCJ;AD8BA;EAQQ,8BAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,yBAAA;ACnCR;ADqCQ;EACI,cAAA;ACnCZ;ADiBA;EAsBY,iBAAA;EACA,+BAAA;EACA,eAAA;ACpCZ;ADsCY;EACI,wBAAA;ACpChB;ADSA;EAiCQ,aAAA;EACA,gBAAA;EACA,mDAAA;EACA,UAAA;ACvCR;ADyCQ;EACI,kBAAA;EACA,mBAAA;ACvCZ","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.style-sub-item {\n    background-color: #F7F7F7;\n    padding: 9px 12px;\n    min-height: 36px;\n    border-radius: 4px;\n    margin-bottom: 8px;\n\n    .sub-item-title {\n        color: var(--bi-jz-font-color);\n        font-size: 12px;\n        font-weight: 500;\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n        user-select: none;\n        transition: all 0.2s ease;\n\n        &:hover {\n            color: #2e74ff;\n        }\n\n        i {\n            margin-right: 6px;\n            transition: transform 0.3s ease;\n            font-size: 12px;\n\n            &.is-expanded {\n                transform: rotate(90deg);\n            }\n        }\n    }\n\n    .sub-item-content {\n        max-height: 0;\n        overflow: hidden;\n        transition: max-height 0.3s ease, padding 0.3s ease;\n        padding: 0;\n\n        &.is-expanded {\n            max-height: 1000px;\n            padding: 12px 0 0 0;\n        }\n    }\n}\n",".style-sub-item {\n  background-color: #F7F7F7;\n  padding: 9px 12px;\n  min-height: 36px;\n  border-radius: 4px;\n  margin-bottom: 8px;\n}\n.style-sub-item .sub-item-title {\n  color: var(--bi-jz-font-color);\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  user-select: none;\n  transition: all 0.2s ease;\n}\n.style-sub-item .sub-item-title:hover {\n  color: #2e74ff;\n}\n.style-sub-item .sub-item-title i {\n  margin-right: 6px;\n  transition: transform 0.3s ease;\n  font-size: 12px;\n}\n.style-sub-item .sub-item-title i.is-expanded {\n  transform: rotate(90deg);\n}\n.style-sub-item .sub-item-content {\n  max-height: 0;\n  overflow: hidden;\n  transition: max-height 0.3s ease, padding 0.3s ease;\n  padding: 0;\n}\n.style-sub-item .sub-item-content.is-expanded {\n  max-height: 1000px;\n  padding: 12px 0 0 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
